<template>
    <form :class="[$style['mds-form'], layoutSizeClass]" :data-mds-version="version">
        <slot></slot>
    </form>
</template>

<script>
    import packageInfo from '../package.json';
    const { name, version } = packageInfo;

    export default {
        name: 'MdsForm',
        data() {
            return {
                version: `${name}-${version}`,
            };
        },
        props: {
            size: {
                type: String,
                default: 'medium',
                validator(value) {
                    return ['small', 'medium', 'large', 'touch'].indexOf(value) !== -1;
                },
                docs: {
                    validation: 'One of: `small`, `medium`, `large`, `touch`.',
                    description:
                        'Sets the spacing applied to elements within the form. This size should always match the size of the components within.',
                },
            },
        },
        computed: {
            layoutSizeClass() {
                return this.$style[`mds-form--${this.size}-layout`];
            },
        },
    };
</script>

<style lang="scss" module>
    @import './form.scss';
</style>
